import { onAuthStateChanged } from 'firebase/auth';
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
// CSS
import '../assets/css/navbar.css';
// Images
import { signOut } from 'firebase/auth';
import Avatar from '../assets/images/avatar.png';
import { auth } from '../firebase-config';
import Branding from '../logo.png';
import PageTransition from './PageTransition';

export default function Navbar() {
  const [user, setUser] = useState('loading');
  const [avatar, setAvatar] = useState(Avatar);
  const [UID, setUID] = useState('');
  const [toggleMenu, setToggleMenu] = useState(false);
  const [pageTransition, setPageTransition] = useState(false);

  onAuthStateChanged(auth, (user) => {
    if(user){
      setUser(true);
      setUID(user.uid);
      
      setTimeout(() => {
        setAvatar(user.photoURL);
      }, 1000)
    }
    else{
      setUser(false);
      setUID('');
    }
  })

  function logoutUser(){
    signOut(auth).then(() => {
      setPageTransition(true);
      setUser(false);
      setUID('');
    }).catch((error) => {
      
    });
  }
  
  return (
    <>
      {
        pageTransition ?
        <PageTransition />
        : <></>
      }

      <nav className="main_nav select_n">
        <div className="container">
          <Link className="nav_left branding" to="/">
            <img src={Branding} alt="CodoHov" />
          </Link>
      
          <ul className="links">
            <li><NavLink to="/" exact>Home</NavLink></li>
            <li><NavLink to="/courses" exact>Courses</NavLink></li>
            <li><NavLink to="/about" exact>About</NavLink></li>
            <li><NavLink to="/contact" exact>Contact</NavLink></li>
          </ul>
      
          <div className="nav_right">
            {
              user === true?
              <>
                <a className="user_img" onClick={() => {setToggleMenu(!toggleMenu)}}>
                  <img src={avatar} alt="User" />
                </a>
                {
                  toggleMenu?
                  <ul className="toggle_menu">
                    <li><NavLink to="/profile" onClick={() => {setToggleMenu(!toggleMenu)}} exact><span className="fas fa-user"></span> Profile</NavLink></li>
                    <li><NavLink to="/my-courses" onClick={() => {setToggleMenu(!toggleMenu)}} exact><span className="fas fa-th-large"></span> My Courses</NavLink></li>
                    <li><NavLink to="/settings" onClick={() => {setToggleMenu(!toggleMenu)}} exact><span className="fas fa-cog"></span> Settings</NavLink></li>
                    <li><a onClick={() => {setToggleMenu(!toggleMenu); logoutUser()}} exact><span className="fas fa-sign-out-alt"></span> Logout</a></li>
                  </ul>
                  :
                  <></>
                }
              </>
              :
              user === false?
              <NavLink to="/login" className="auth_btn ripple-animate ripple-light btn_primary bg-2"><span className="fas fa-sign-in-alt"></span> লগ ইন</NavLink>
              :
              <></>
            }
          </div>
        </div>
      </nav>
    </>
  )
}
